export default __webpack_public_path__ + "static/media/score.7b39727c.png";